export default __webpack_public_path__ + "static/media/img3.2235a8bb.jpg";